module.exports = "/images/53c257f24e7b3bf441dcc688abee49ca.svg";